import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/business-plan")({
  component: () => <Outlet />,
});

